module.exports = __webpack_public_path__ + "img/UCL360_banner4.94c300aa.png";